export const fbAppId = (env?: string): string => {
	return env === 'prod' ? '2773133082797983' : '402670860613108'
}
